import React from 'react';

import Table, {
  TableFooter,
  TablePagination,
  TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import LinearProgress from 'material-ui/Progress';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import {
  Add,
  Close,
  Check,
  Edit,
  MoreVert
} from 'material-ui-icons';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';
import Editation from '../../offers/routes/Editation';
import MenuItem from 'material-ui/Menu/MenuItem';
import Menu from 'material-ui/Menu';
import tsl from '../../../tsl';
import Filter from '../../offers/routes/Filter';

import axios from 'axios';
import moment from "moment-timezone";

class TransferList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      filter: {},
      rowsPerPage: 10,
      page: 0,
      total: 0,
      data: [],
      entity: {},
      formDisplay: false,
      menuElement: null
    };
  }

  componentDidMount() {
    this.loadEntities(1);

    axios.get('/api/operator/flight/locations')
    .then((res) => {
      this.setState({locations: res.data.data.sort((a, b) => a.name.localeCompare(b.name))});
    });
  }

  loadEntities(page) {
    const {
      type
    } = this.state;

    axios.get('/api/operator/flight/offers?type=transfers&page=' + page + '&perPage=' + this.state.rowsPerPage, {
      params: this.state.filter
    })
      .then((response) => {
        //console.log(response.data);
        this.setState({
          data: response.data.data,
          page: response.data.current_page,
          total: response.data.total,
          rowsPerPage: parseInt(response.data.per_page),
          //entity: response.data.data[0]
        });
      });
  }

  handleChangePage(e, page) {
    this.loadEntities(page + 1);	// paginator counts pages as indexes (starting 0)
  }

  handleClick = (model) => (e) => {
    this.setState({
      entity: model,
      formDisplay: true,
    });
    // TODO: Focus to editation form
  };

  handleSecondaryAction = (model) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      menuEntity: model,
      menuElement: e.currentTarget,
    });
    // TODO: Focus to editation form
  };

  handleCloseMenu = () => {
    this.setState({
      menuElement: null,
      menuEntity: null
    });
  };

  closeEditation = () => {
    this.setState({
      entity: {},
      formDisplay: false,
    });
  };

  saveEntity = (model) => {
    if (!model.files) {
      model.files = [];	// when
    }

    if (model.start_time) {
      const utcTime = moment(model.start_time).utc().toISOString();
      model.start_time = utcTime;
    }

    axios.post('/api/operator/flight/offers' + (model.id ? '/' + model.id : ''), model)
      .then((response) => {
        // TODO: feedback (success or failure)
        // TODO: here update data (call reloading of current page)
        this.closeEditation();

        this.loadEntities(this.state.page);
      });
  };

  createNew = () => {
    this.setState({
      entity: {
        files: [],
        flight_type: {
          id: 8
        },
        is_transfer: true
      },
      formDisplay: true
    });
  };

  renderStatusIcon = (status) => {
    if (!status.name) {
      return null;
    }
    let bgColor = 'white',
      color = 'silver',
      icon = <Edit/>;

    switch (status.name.toUpperCase()) {
      case 'ACTIVE':
        bgColor = "white";
        color = "green";
        icon = (<Check/>);
        break;

      case 'CANCELED':
        bgColor = "white";
        color = "red";
        icon = (<Close/>);
        break;

      case 'DRAFT':
      default:
        bgColor = "white";
        color = "silver";
        icon = (<Edit/>);
    }

    return (
      <Avatar style={{color: color, backgroundColor: bgColor}}>
        {icon}
      </Avatar>
    );
  };

  duplicateEntity = (entity) => {
    return {
      ...entity,
      id: undefined,
      files: entity.files.map(o => ({ ...o, id: undefined })),
      aircraft_offers: entity.aircraft_offers.map(o => ({ ...o, id: undefined })),
      availability: entity.availability.map(o => ({ ...o, id: undefined })),
      route: {
        points: entity.route.points.map(o => ({ ...o, id: undefined }))
      },
    }
  };

  createDuplicate = () => {
    this.setState({
      entity: this.duplicateEntity(this.state.menuEntity),
      formDisplay: true,
      menuElement: null,
      menuEntity: null,
    });
  };

  createReturnOffer = () => {
    const duplicate = this.duplicateEntity(this.state.menuEntity);
    this.setState({
      entity: {
        ...duplicate,
        // #15988 Transfer Flights: reverse route, times are not exchanged
        time_pickup: this.state.menuEntity.time_return,
        time_return: this.state.menuEntity.time_pickup,
        time_before: this.state.menuEntity.time_dropoff,
        time_dropoff: this.state.menuEntity.time_before,
        dropoff_location: this.state.menuEntity.location,
        location: this.state.menuEntity.dropoff_location,
        route: {
          points: duplicate.route.points.reverse().map((p, i) => ({ ...p, position: 1+i}))
        },
        translations: this.state.menuEntity.translations.map(t => ({
          ...t,
          // generate new translations for the title
          title: tsl('offers.edit.transfer_title', {
            pickup: this.state.menuEntity.dropoff_location.name,
            dropoff: this.state.menuEntity.location.name,
          })
        }))
      },
      formDisplay: true,
      menuElement: null,
      menuEntity: null,
    });
  };

  deleteOffer = () => {
    this.setState({
      menuElement: null,
      menuEntity: null,
    });

    axios.delete(`/api/operator/flight/offers/${this.state.menuEntity.id}`).then(() => {
      this.loadEntities(this.state.page);
    });
  };

  handleFilterChange = (filter) => {
    this.setState({
      filter
    }, () => this.loadEntities(1));
  };

  render() {
    return (
      <div>

        <Filter
          dropoff
          onChange={this.handleFilterChange}
          locations={this.state.locations}
        />

        <div style={this.state.formDisplay ? {} : {display: "none"}}>
          <Editation
            key={`${this.state.type}_${(this.state.entity && this.state.entity.id || 'new')}`}
            ref="editationForm"
            entityData={this.state.entity ? this.state.entity : {}}
            saveEntity={this.saveEntity}
            closeEditation={this.closeEditation}
          />
        </div>

        {this.state.formDisplay ? '' :

          <div>
            <Button raised fab color="accent"
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.createNew}
            >
              <Add/>
            </Button>

            <Paper>
              <div className="flex-auto">
                <div className="table-responsive-material">
                  <List>
                    {this.state.data.map((model, index) => {
                      return (<div key={model.id}>
                          <ListItem button
                                    onClick={this.handleClick(model)}
                          >
                            {this.renderStatusIcon(model.status)}
                            <Grid container spacing={0}>
                              <Grid item sm={5} xs={12}>
                                <ListItemText className="br-break"
                                              primary={<span><i
                                                className="zmdi zmdi-flight-takeoff"/>{' '}{(model.location.name || '-')}</span>}
                                              secondary={model.title}
                                />
                              </Grid>

                              <Grid item sm={5} xs={12}>
                                <ListItemText className="br-break"
                                              primary={<span><i
                                                className="zmdi zmdi-flight-land"/>{' '}{(model.dropoff_location && model.dropoff_location.name || '-')}</span>}
                                />
                              </Grid>

                              <Grid item sm={2} xs={12}>
                                <ListItemText className="br-break"
                                              primary={<span><i
                                                className="zmdi zmdi-timer"/>{' '}{(model.blocking_time || '-')} min</span>}
                                />
                              </Grid>
                            </Grid>
                            <ListItemSecondaryAction>
                              <IconButton onClick={this.handleSecondaryAction(model)}>
                                <MoreVert />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <Divider light/>
                        </div>
                      );
                    }, this)}

                  </List>

                  <Table className="">
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          count={this.state.total}
                          rowsPerPage={this.state.rowsPerPage}
                          rowsPerPageOptions={[this.state.rowsPerPage]}
                          page={this.state.page - 1}
                          onChangePage={(e, page) => {
                            this.handleChangePage(e, page)
                          }}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              </div>
            </Paper>

            <Menu
              open={this.state.menuElement !== null}
              anchorEl={this.state.menuElement}
              onClose={this.handleCloseMenu}
            >
              <MenuItem onClick={this.createDuplicate}>{tsl('offers.duplicate')}</MenuItem>
              <MenuItem onClick={this.createReturnOffer}>{tsl('offers.reverse')}</MenuItem>
              <MenuItem onClick={this.deleteOffer}>{tsl('offers.delete')}</MenuItem>
            </Menu>
          </div>

        }

      </div>
    );
  }
}

export default TransferList;


// WEBPACK FOOTER //
// ./app/used/transfers/routes/List.js